import { get, filter } from "lodash"
import { createSelector } from "reselect"
import { getIsOpPro } from "modules/account-root/selectors"
import { computeEntityPermissionsTabs } from "helpers/permissions/tabs"
import { getPath, getRoute } from "selectors/urls"
import { getRole } from "helpers/permissions/roles"
import { getIsPatFeatureEnabled } from "selectors/features"

const EMPTY_ARRAY = []

export const getTokens = state => get(state, "global.data.tokens.data.tokens")
const getFeatures = state => get(state, "global.data.features.data")
export const getTokenFeatures = state => get(state, "modules.tokens.tokenFeatures", EMPTY_ARRAY)
export const getTokenFeaturesLoading = state => get(state, "modules.tokens.tokenFeaturesLoading")
export const getAccountFeatures = state => get(state, "global.data.accountFeatures.data", EMPTY_ARRAY)

export const getTabs = createSelector(
  [getRoute, getPath, getIsOpPro, getRole, getIsPatFeatureEnabled],
  computeEntityPermissionsTabs,
)
export const getRestrictedFeatures = createSelector(
  [getFeatures],
  (features) => filter(features, ({ status }) => status === "restricted"),
)
